import 'Styles/releasenotes.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import rawToReact from 'Utils/bbcode/RawToReact';

import releaseNotesSelector from 'Selectors/releaseNotesSelector';

import Date from 'Components/common/dateComponent';

export class ReleaseNotesListComponent extends React.Component {
	expandNotification = ( e ) => {
		e.stopPropagation();
		e.currentTarget.classList.toggle( 'showNote' );
		return true;
	};

	buildNote = ( note ) => {
		return (
			<div className='releaseNote' key={ note.n_id } onClick={ this.expandNotification }>
				<div className='noteTitle'>
					{[note.n_title]}
					<p><Date timestamp={ note.n_timestamp_unix } icon={ true } /></p>
				</div>
				<div className='noteContent' >
					{ rawToReact( note.n_text.replace( /\n\t/ig, '').replace( /\n\n/ig, '\n ') ) }
				</div>
			</div>
		);
	};

	buildPage = ( pageNum ) => {
		const { entities, result } = this.props.releaseNotes;

		let releaseNotes = result.notes.filter( e => entities.notes[ e ] && entities.notes[ e ].page === pageNum ),
			notesList = releaseNotes.map( ( id, i ) => this.buildNote( entities.notes[ id ] ) );

		return (
			<ul key={pageNum} className={`scroll_page page_${pageNum}`}>
				{ notesList }
			</ul>
		)
	};

	releaseNotesPage () {
		return this.props.pages.map( ( pageNum ) => this.buildPage( pageNum ) );
	}

	render() {
		return (
			<div ref={ this.props.listRef } className='releaseNoteContainer'>
				{ this.releaseNotesPage() }
			</div>
		);
	}
}

ReleaseNotesListComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	pages: PropTypes.array.isRequired,
};

export default connect( releaseNotesSelector )( ReleaseNotesListComponent );



// WEBPACK FOOTER //
// ./src/components/releasenotes/ReleaseNotesListComponent.js